export default __webpack_public_path__ + "static/media/f_logo_RGB-White_1024.png";